import { css } from '@emotion/react'
import {
  Button,
  type ButtonProps,
  SpacingToken,
} from '@livechat/design-system-react-components'

import { AMPLITUDE_EVENTS, EVENT_SOURCE_IDS } from '@/constants'
import { addProduct, addProductForNotLoggedIn } from '@/store/cart'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import { isAuthorized, isAddingProduct, getItemById } from '@/store/selectors'
import auth from '@/utils/auth'
import useParamSelector from '@/hooks/useParamSelector'
import { logAmplitudeEvent } from '@/store/stats'

export const btnCss = css`
  white-space: nowrap;
  margin-right: var(${SpacingToken.Spacing2});
`

const sourceId = EVENT_SOURCE_IDS.ADD_TO_CART_BUTTON

interface Props extends ButtonProps {
  id: string
}

export const AddToCartButton = ({ id }: Props) => {
  const isUserAuthorized = useTypedSelector(isAuthorized)
  const isAddingProductToCart = useParamSelector(isAddingProduct, id)
  const appName = useParamSelector(getItemById, id).name
  const dispatch = useTypedDispatch()

  const handleClick = () => {
    dispatch(
      logAmplitudeEvent({
        name: AMPLITUDE_EVENTS.ADD_TO_CART_CLICKED,
        params: {
          appId: id,
          appName,
        },
      })
    )

    if (isUserAuthorized) {
      dispatch(addProduct.pending({ productId: id, sourceId }))
    } else {
      dispatch(addProductForNotLoggedIn.pending({ productId: id, sourceId }))
      auth.signIn()
    }
  }

  return (
    <Button
      data-test="buy-btn"
      kind="text"
      onClick={handleClick}
      fullWidth
      loading={isAddingProductToCart}
      css={btnCss}
    >
      Add to Cart
    </Button>
  )
}

export default AddToCartButton
